import axios from 'axios'
import store from '../store'

const API = axios.create({
  baseURL: process.env.VUE_APP_API_OMNI_USUARIO
})

// Intercepta a requisição e adiciona o Authorization
API.interceptors.request.use((config) => {
  const token = store.state.login.token
  if (token) {
    config.headers.Authorization = token
  }
  return config
}, (err) => Promise.reject(err))

export default {
  validaLogin (params) {
    return API.post('login', params)
  },
  revitalizarToken () {
    return API.get('login/revitalizar')
  },
  validaContexto (contexto) {
    return API.get(`login/contexto/${contexto}`)
  },
  selecionaOperadora (operadora) {
    return API.put(`/omniUsuario/selectCliente/${operadora}`)
  },
  esqueciMinhaSenha (params) {
    return API.post('login/forgot_password', params)
  },
  recuperaSenha (token, params) {
    return API.post(`login/recovery_password/${token}`, params)
  },
  logout (params) {
    API.get(`logout`, params).then((res) => {
      return res
    }).catch(() => {
      return axios.get(`${process.env.VUE_APP_API_OMNI_USUARIO_AN}/logout`, params)
    })
  },
  getUsuario (token) {
    return API.get('omniUsuario/session', { headers: { Authorization: token } })
  },
  getDashboardCards () {
    return API.get('setup/dashboard/cards')
  },
  getFormId () {
    return API.get('login/painelConfigs')
  }
}
